import * as React from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { Province } from "@models/province";
import { deleteRequest, fetchRequest } from "@actions/province";
import ProvincesTable from "@components/provinces/Table";
import { Button, Card } from "antd";
import TableRenderer from "@hocs/TableRenderer";
import { FormattedMessage } from "react-intl";
import { getProvincesList } from "@reducers/province";
import SearchProvinceComponent from "@components/provinces/Search";
import { NavLink } from "react-router-dom";

interface PropsFromState {
  loading: boolean;
  data: Province[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class ProvincesIndexPage extends React.Component<AllProps> {
  deleteProvince = (item: Province): any => {
    this.props.deleteRequest({
      params: {
        id: item.id
      }
    });
  };

  render() {
    const { loading, data, search, currentPage } = this.props;
    return (
      <div>
        <div className={`toggle-button-wrapper`}>
          <NavLink to={`/provinces/create`}>
            <Button type={"primary"}>
              <FormattedMessage
                id="app.create_new_province"
                defaultMessage={`Create Province`}
              />
            </Button>
          </NavLink>
        </div>
        <div className={"page-table-wrapper"}>
          <Card className={`page-table-header`} bordered={false}>
            <SearchProvinceComponent search={search} />
          </Card>

          <ProvincesTable
            data={data}
            currentPage={currentPage}
            rowKey={record => record.id}
            deleteFn={this.deleteProvince}
            loading={loading}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ provinces }: ApplicationState) => ({
  loading: provinces.loading,
  data: getProvincesList(provinces),
  count: provinces.count
});

const mapDispatchToProps = {
  fetchRequest,
  deleteRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableRenderer(ProvincesIndexPage));
